import { Box, Container, Grid, Typography, Card, CardContent, Chip } from '@mui/material';
import { Calendar, ArrowRight } from 'lucide-react';

export function LatestNews({ data }) {
  const primaryColor = data.primary_color || '#1e3a8a';
  const news = Array.isArray(data.news) ? data.news : [];

  if (news.length === 0) return null;

  return (
    <Box sx={{ py: { xs: 8, md: 10 }, backgroundColor: '#ffffff' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', maxWidth: 640, mx: 'auto', mb: 6 }}>
          <Box sx={{ display: 'inline-block', px: 2, py: 0.5, borderRadius: 4, backgroundColor: `${primaryColor}15`, color: primaryColor, mb: 1.5 }}>
            <Typography variant="caption" fontWeight={700} letterSpacing="0.05em">
              NEWS & ANNOUNCEMENTS
            </Typography>
          </Box>
          <Typography variant="h2" fontWeight={800} color="#0f172a" sx={{ fontSize: { xs: '2rem', md: '2.5rem' }, mb: 1 }}>
            Latest School News
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Read the latest updates, press releases, and academic achievements.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {news.map((item, index) => (
            <Grid size={{ xs: 12, md: 4 }} key={item.id || index}>
              <Card
                elevation={0}
                sx={{
                  p: 3,
                  height: '100%',
                  borderRadius: 4,
                  backgroundColor: '#f8fafc',
                  border: '1px solid #e2e8f0',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: '#ffffff',
                    boxShadow: '0 15px 35px rgba(0,0,0,0.08)',
                    borderColor: primaryColor,
                  },
                }}
              >
                <Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                    {item.category && (
                      <Chip
                        label={item.category}
                        size="small"
                        sx={{ backgroundColor: `${primaryColor}15`, color: primaryColor, fontWeight: 700 }}
                      />
                    )}
                    {item.date && (
                      <Typography variant="caption" color="text.secondary" fontWeight={600}>
                        {item.date}
                      </Typography>
                    )}
                  </Box>

                  <Typography variant="h6" fontWeight={800} color="#0f172a" sx={{ mb: 1.5, lineHeight: 1.3 }}>
                    {item.title}
                  </Typography>

                  {item.summary && (
                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                      {item.summary}
                    </Typography>
                  )}
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default LatestNews;
